









































































// libs
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import lodashGet from 'lodash/get';

import { UserTreatment } from '@/models/user-treatment';

// constants
import {
  makeUserTreatmentState,
  USER_TREATMENT_NAME,
  USER_TREATMENT_STATE,
} from '@common/constants/auth';
import { formatDateTimeJp } from '@common/app.config';
import { User } from '@/models/user';

@Component({
  components: {},
})
export default class UserTreatmentItem extends Vue {
  @State((state) => state.treatment_detail.data)
  activeUserTreatment: UserTreatment;
  @State((state) => state.treatment_detail.activeTab) activeTab: string;
  @Prop({ required: true }) treatment: UserTreatment;
  @State((state) => state.auth.currentUser) currentUser!: User;

  private formatDateTimeJp = formatDateTimeJp;
  private unreadCount = 0;

  mounted() {
    if (
      this.$route.query.user_treatment_id &&
      this.treatment.id ==
        parseInt(this.$route.query.user_treatment_id as string)
    ) {
      this.$store.commit('treatment_detail/setTreatment', this.treatment);
    } else if (!this.$route.query.user_treatment_id) {
      this.$store.commit('treatment_detail/setTreatment', this.treatment);
    }

    (this.$root as any).$on('UpdateUnreadCount', this.onUnreadMessageUpdate);
    (this.$root as any).$on('UpdateLatestMessage', this.onMessageCreated);
  }

  beforeDestroy() {
    (this.$root as any).$off('UpdateUnreadCount', this.onUnreadMessageUpdate);
    (this.$root as any).$off('UpdateLatestMessage', this.onMessageCreated);
  }

  // ********************* methods ********************* //
  private onMessageCreated = (data) => {
    const { data: activeTreatment, activeTab } = this.$store.state.treatment_detail;
    const { reservation_id } = data;

    if (activeTreatment.reservation_id !== reservation_id) {
      return;
    }

    const isChatTab = activeTab === 'chat';
    const isActive = activeTreatment.reservation_id === reservation_id;
    if (isActive && isChatTab) {
      this.unreadCount = 0;
    } else {
      this.unreadCount++;
    }
  }

  private onUnreadMessageUpdate = (data) => {
    const { data: activeTreatment, activeTab } = this.$store.state.treatment_detail;

    if (!activeTreatment) {
      return;
    }

    const { reservationId, unreadMessageCount } = data;
    const isActive = activeTreatment.reservation_id === reservationId;
    const isChatTab = activeTab === 'chat';

    if (isActive && isChatTab) {
      this.unreadCount = 0;
      this.$store.commit('user_treatment_list/syncUnreadCount', {
        reservationId,
        unreadMessageCount: 0,
      });
      return;
    }

    if (!isActive && unreadMessageCount !== 0) {
      this.$store.commit('user_treatment_list/syncUnreadCount', data);
    } else if (isActive && !isChatTab) {
      this.$store.commit('user_treatment_list/syncUnreadCount', data);
    } else {
      this.unreadCount = 0;
    }
  }

  @Watch('treatment', { deep: true, immediate: true })
  private onTreatmentChange(val: UserTreatment) {
    const isActive = this.activeUserTreatment?.id === val.id;
    const isChatTab = this.activeTab === 'chat';

    if (isActive && isChatTab) {
      this.unreadCount = 0;
      return;
    }

    this.unreadCount = val.unread_message || 0;
  }

  @Watch('activeTab')
  private onTabChange(tab: string) {
    const isActive = this.activeUserTreatment?.id === this.treatment.id;
    if (isActive && tab === 'chat') {
      this.unreadCount = 0;
      this.treatment.reservations?.forEach((r) => {
        this.$store.commit('user_treatment_list/syncUnreadCount', {
          reservationId: r.id,
          unreadMessageCount: 0,
        });
      });
    }
  }

  private handelClickTreatment() {
    this.$store.commit('treatment_detail/setLoading');
    this.$store.commit('treatment_detail/setTreatment', this.treatment);
    setTimeout(() => {
      this.$store.commit('treatment_detail/setLoading', false);
    }, 100);
  }

  private getNameByKey = (key) => USER_TREATMENT_NAME[key.toLocaleUpperCase()];
  private makeUserTreatmentState(state) {
    return makeUserTreatmentState(state, this.currentUser);
  }

  private getMenuNameByUserTreatment = (treatment) =>
    treatment.menu?.name || '-'

  private getReservationDateUserTreatment = (treatment) =>
    lodashGet(treatment, 'reservations[0].latest_answer.created_at')
  private getFirstPaidAt = (treatment) => treatment.orders[0]?.paid_at;
  private getPlanName = (treatment) => treatment.orders[0]?.plan?.name;
  private checkReverse = (treatment) => {
    if (treatment.feedback_type === USER_TREATMENT_STATE.DOCTOR_RESERVE_PRESCRIPTION) {
      return true;
    } else {
      return false;
    }
  }

  get handlerText() {
    const type = this.treatment?.handler_type;
    if (!type) {
      return '';
    }

    const TEXT_MAP = {
      cs: 'CS対応中',
      doctor: 'ドクター対応中',
    };

    return TEXT_MAP[type] || 'ドクター対応中';
  }
}
